import type {ToastProps} from '@Components/toast/toast.types';

export interface DismissibleToastProps extends ToastProps {
  duration?: number;
}

export interface ShowToastOpts extends DismissibleToastProps {
  useMaxZIndex?: boolean;
}

export const DEFAULT_DURATION = 3000;
